<template>
  <div :class="video_popup_class" @click="click_close_popup">
    <div class="popup_video_container relative">
      <div class="option-bar" @click="click_close_popup">
        <span class="close-link">X</span>
      </div>
      <img src="static/content/instructions-popup.jpg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "ImagePopup",
  data() {
    return {
      timer: null
    };
  },
  computed: {
    video_popup_class() {
      return "popup";
    }
  },
  methods: {
    click_close_popup(e) {
      e.preventDefault();
      this.close_popup(e);
    },
    close_popup(e) {
      console.log("close popup");
      if (this.timer != null) clearTimeout(this.timer);
      this.$store.dispatch("set_popup_state", "");
      this.$store.dispatch("set_simple_val", {
        name: "instructions_shown",
        val: true
      });
    },

    prevent_close(e) {
      e.stopPropagation();
    },
    onPopupTimeout() {
      this.close_popup(null);
    }
  },
  mounted() {
    if (this.timer != null) clearTimeout(this.timer);

    this.timer = setTimeout(
      function () {
        this.onPopupTimeout();
      }.bind(this),
      180000
    );
  },
  beforeDestroy() {
    if (this.timer != null) clearTimeout(this.timer);
    this.$bus.$off("on-request-video-close", this.close_popup);
  }
};
</script>
<style scoped>
.popup {
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  cursor: pointer;
}

.popup_video_container {
  align-self: center;
  margin: 0 0;
}
.popup_video_container img {
  height: auto;
  max-width: 90vw;
  max-height: 90vh;
  margin: 0 auto;
  cursor: pointer;
  -webkit-user-drag: none;
  user-drag: none;
}
.option-bar {
  position: absolute;
  top: 15px;
  right: 25px;
  width: 80px;
  height: 80px;
}
.close-link {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  display: inline-block;
  xbackground: url("../../assets/close.png") 0 0 no-repeat;
  xbackground-size: cover;
  width: 70px;
  height: 70px;
  overflow: hidden;
  text-align: left;
  text-indent: -1000px;
}

@media only screen and (max-width: 1110px) {
  .popup .option-bar {
    top: -50px;
    right: 0;
  }
}
@media only screen and (max-width: 1110px) and (max-height: 460px) {
  .popup .option-bar {
    top: 5px !important;
    right: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/InstructionsPopup.vue